<template>
  <span>
   <svg t="1608165858941"  @click="$emit('click')" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="3210" xmlns:xlink="http://www.w3.org/1999/xlink"
        :width="width"
        :height="height">
     <path :style="{fill:color }" d="M925.1 337c-22.6-53.4-54.9-101.3-96.1-142.5-41.2-41.2-89.1-73.5-142.5-96.1C631.2 75 572.5 63.2 512 63.2S392.8 75.1 337.5 98.4C284.1 121 236.2 153.3 195 194.5c-41.1 41.2-73.4 89.2-96 142.5-23.4 55.3-35.2 114-35.2 174.5S75.6 630.7 99 686c22.6 53.4 54.9 101.3 96.1 142.5 41.2 41.2 89.1 73.5 142.5 96.1 55.3 23.4 114 35.2 174.5 35.2s119.2-11.9 174.5-35.2c53.4-22.6 101.3-54.9 142.5-96.1 41.2-41.2 73.5-89.1 96.1-142.5 23.4-55.3 35.2-114 35.2-174.5-0.1-60.5-12-119.2-35.3-174.5zM444.2 910.5C288.3 885 138.6 735.3 113.1 579.4 68 303.5 304.1 67.5 579.9 112.6 735.8 138.1 885.5 287.8 911 443.7c45.1 275.8-191 511.8-466.8 466.8z" p-id="3211"></path>
     <path :style="{fill:color }" d="M649.6 631h-275c-10.9 0-21.3-2.9-29.4-8.3-9.6-6.4-15.1-15.6-15.1-25.4V464.1c-0.6-0.1-1.4-0.3-2.4-0.3h-91c-19.7 0-36.3-9.1-42.4-23.2-5.3-12.3-1.1-25.6 11.1-34.6l275.4-204.6c17.3-12.8 45.3-12.8 62.6 0L818.8 406c12.1 9 16.4 22.3 11.1 34.6-6.1 14.1-22.7 23.2-42.4 23.2h-91c-1 0-1.8 0.1-2.4 0.3v133.2c0 9.8-5.5 19.1-15.1 25.4-8.1 5.4-18.6 8.3-29.4 8.3z m-277.3-36.7c0.6 0.1 1.4 0.3 2.4 0.3h274.9c1 0 1.8-0.1 2.4-0.3V461.1c0-9.8 5.5-19.1 15.1-25.4 8.1-5.3 18.5-8.3 29.4-8.3H783L515.9 229c-1.4-1.1-6.2-1.1-7.6 0L241.2 427.4h86.5c10.9 0 21.3 2.9 29.4 8.3 9.6 6.4 15.1 15.6 15.1 25.4v133.2z m419-160.7l13.8-13.8-13.8 13.8zM687.3 701.5H336.9c-9.3 0-16.8-8.2-16.8-18.2 0-10.1 7.5-18.2 16.8-18.2h350.5c9.3 0 16.8 8.2 16.8 18.2-0.1 10-7.6 18.2-16.9 18.2zM751.1 767.8H272.6c-9.1 0-16.6-8.2-16.6-18.2 0-10.1 7.4-18.2 16.6-18.2h478.5c9.1 0 16.6 8.2 16.6 18.2 0 10.1-7.4 18.2-16.6 18.2z" p-id="3212"></path></svg>
  </span>
</template>

<script>
  export default {
    name: "UpdateIcon",
    props: {
      none: {type: Boolean, default: false},
      height: {type: String, default: '31px'},
      width: {type: String, default: '31px'},
    },
    data: () => ({
      color: "#0e932e",
    }),
    watch: {
      'none': 'refreshIcon',
    },
    methods: {
      refreshIcon() {
        if (this.none) {
          this.color = '#bfbfbf';
        } else {
          this.color = '#0e932e';
        }
      }
    }
  }
</script>
<style scoped>
</style>